import {StyleCategoryName} from '../../base/types';

export const BaseLayoutStyleCategories: StyleCategoryName[] = [
  'padding',
  'border',
  'size',
  'position',
  'flexDirection',
  'flex',
  'visibility',
  'pointerEvents',
  'shadow',
  'overflow',
];
